import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

export type DashboardProjectWindowDates = {
  start: string;
  finish: string;
};

type DashboardSidebarContextValue = {
  projectWindowDates: DashboardProjectWindowDates;
  setProjectWindowDates: (dates: DashboardProjectWindowDates) => void;
};

const defaultDates: DashboardProjectWindowDates = { start: '-', finish: '-' };

const DashboardSidebarContext = createContext<DashboardSidebarContextValue | null>(null);

export function DashboardSidebarProvider({ children }: { children: React.ReactNode }) {
  const [projectWindowDates, setDates] = useState<DashboardProjectWindowDates>(defaultDates);

  const setProjectWindowDates = useCallback((dates: DashboardProjectWindowDates) => {
    setDates(dates);
  }, []);

  const value = useMemo(
    () => ({ projectWindowDates, setProjectWindowDates }),
    [projectWindowDates, setProjectWindowDates]
  );

  return (
    <DashboardSidebarContext.Provider value={value}>{children}</DashboardSidebarContext.Provider>
  );
}

export function useDashboardSidebarOptional() {
  return useContext(DashboardSidebarContext);
}

export function useDashboardSidebar() {
  const ctx = useContext(DashboardSidebarContext);
  if (!ctx) {
    throw new Error('useDashboardSidebar must be used within DashboardSidebarProvider');
  }
  return ctx;
}
